import { useStateContext } from 'context/StateContext'
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import { Helmet } from 'react-helmet-async';

export default function About() {
    const { darkMode } = useStateContext()

    return (
        <>
            <Helmet>
                {/* <Helmet/> component is used to change title, description and tags for each pages. Normally ReactJS use just one "html" file so we can't change title 
        for each page. Helmet is an external library used to add this feature */}
                <meta charSet="utf-8" />
                <title>Steven Eric | About Me</title>
            </Helmet>
            <div className="container" id='about-section' data-aos="fade-right">
                <div className="row py-4 ">
                    <div className="col text-style position-relative d-flex justify-content-center">
                        <h1 className={`${darkMode ? "text-body" : "text-body-tertiary"} fw-bold `}>ABOUT ME</h1>
                        <h4 className='position-absolute align-self-center '>Know Me More</h4>
                    </div>
                </div>

                {/* personal information */}
                <div className="row px-2 px-sm-4 px-lg-5 mt-4">
                    <div className="col-12 col-xl-5 d-flex align-items-center">
                        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quis sapiente amet illo temporibus officia commodi facere repudiandae dolore, quibusdam totam, quas voluptatibus nisi nostrum distinctio assumenda quae fugit laudantium rem obcaecati vel laborum libero modi! Cum, eligendi consectetur accusantium placeat corporis voluptatem adipisci, est dolorum fugit ratione non asperiores saepe!</p>
                    </div>
                    <div className="col mt-4 mt-xl-0 ps-auto ps-md-3 ps-xl-4">
                        <div className="row g-3 row-cols-1 row-cols-sm-2">
                            <div className="col">
                                <strong>First Name: </strong> Steven
                            </div>
                            <div className="col">
                                <strong>Last Name: </strong> Eric
                            </div>
                            <div className="col">
                                <strong>Birth Date: </strong> 01 Sep 1970
                            </div>
                            <div className="col">
                                <strong>Nationality: </strong> United States
                            </div>
                            <div className="col">
                                <strong>Languages: </strong> English, Italian
                            </div>
                            <div className="col">
                                <strong>Experience: </strong> 5+ years
                            </div>
                            <div className="col">
                                <strong>Address: </strong> Kingston, New York 12401
                            </div>
                            <div className="col">
                                <strong>Freelance: </strong> Available
                            </div>
                            <div className="col">
                                <strong>Phone: </strong> <a className='text-body' href="#">(415)&nbsp;555&#8209;0132</a>
                            </div>
                            <div className="col">
                                <strong>Email: </strong> <a className='text-body' href="#">abc@gmail.com</a>
                            </div>
                        </div>
                    </div>
                </div>


                {/* education */}
                <div className="row">
                    <div className="col px-0 px-md-2 px-lg-4 ">
                        <h2 className="fw-bold mt-5 mb-5 px-3 px-sm-4 ">Education</h2>
                        <div className="timeline mb-5 ">
                            <div className="container left" >
                                <div className="content shadow text-body">
                                    <p className='bg-body-secondary shadow mb-4 rounded-pill px-2 d-flex gap-2 align-items-center'>
                                        <CalendarMonthOutlinedIcon fontSize='small' /> 1985 - 1987
                                    </p>
                                    <h5>Computer Science</h5>
                                    <h6 className='text-warning'>Cambridge University</h6>
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repellendus, assumenda?</p>
                                </div>
                            </div>
                            <div className="container right">
                                <div className="content shadow text-body">
                                    <p className='bg-body-secondary shadow mb-4 rounded-pill px-2 d-flex gap-2 align-items-center'>
                                        <CalendarMonthOutlinedIcon fontSize='small' /> 1987 - 1989
                                    </p>
                                    <h5>Bachelor Degree</h5>
                                    <h6 className='text-warning'>University of Tokyo</h6>
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repellendus, assumenda?</p>
                                </div>
                            </div>
                            <div className="container left">
                                <div className="content shadow text-body">
                                    <p className='bg-body-secondary shadow mb-4 rounded-pill px-2 d-flex gap-2 align-items-center'>
                                        <CalendarMonthOutlinedIcon fontSize='small' /> 1989 - 1993
                                    </p>
                                    <h5>Master Degree</h5>
                                    <h6 className='text-warning'>Harvard University</h6>
                                    <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Repellendus, assumenda?</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div >
        </>
    )
}
